import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../stack/integrations/components/IntegrationImage";

export const FooterGap = ({ notification }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      alignItems: "center",
      cursor: "pointer",
    }}
  >
    <IntegrationImage
      name={notification.icon_name}
      width={"16px"}
      newLogo={true}
    />
    <Typography variant="caption">#{notification.label}</Typography>
  </Box>
);
